// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2e1SI","requiredAsterisk":"Info_requiredAsterisk__3vRlh"};